import { useConfig } from '../api/queries';
import { VAMark } from '../components/Brand';
import { IconApple, IconCheck, IconWindows } from '../components/icons';

export function DownloadAppPage() {
  const config = useConfig();
  const win = config.data?.desktopDownloads.win;
  const mac = config.data?.desktopDownloads.mac;
  const winSigned = !!win && !!config.data?.desktopDownloads.winSigned;
  const macSigned = !!mac && !!config.data?.desktopDownloads.macSigned;
  return (
    <div className="container">
      <section className="hero" style={{ gridTemplateColumns: '1fr', textAlign: 'center', justifyItems: 'center' }}>
        <VAMark className="auth-mark" />
        <span className="eyebrow">The VA Plugin Store app</span>
        <h1 style={{ maxWidth: 820 }}>
          Install, try and unlock in <em>one click</em>.
        </h1>
        <p className="hero-lead" style={{ margin: '0 auto 26px' }}>
          The app installs plugins straight into Resolume, keeps them up to date, and unlocks everything you own on this computer. Sign in on a new machine and your library is right there.
        </p>
        <div className="row wrap" style={{ justifyContent: 'center' }}>
          {win ? (
            <a className="btn btn-primary btn-lg" href={win}><IconWindows /> Download for Windows</a>
          ) : (
            <span className="btn btn-outline btn-lg" aria-disabled><IconWindows /> Windows: coming soon</span>
          )}
          {mac ? (
            <a className="btn btn-primary btn-lg" href={mac}><IconApple /> Download for macOS</a>
          ) : (
            <span className="btn btn-outline btn-lg" aria-disabled><IconApple /> macOS: coming soon</span>
          )}
        </div>
        <div className="trust-row" style={{ justifyContent: 'center' }}>
          {/* Only what's true, per platform: "signed" once DESKTOP_WIN_SIGNED / DESKTOP_MAC_SIGNED is on. */}
          <span><IconCheck size={16} /> Windows 10/11 (64-bit){winSigned ? ', signed by Visual Artform Inc.' : ''}</span>
          {mac && <span><IconCheck size={16} /> macOS 13 or later, Apple Silicon and Intel{macSigned ? ', signed and notarized' : ''}</span>}
        </div>
        {mac && !macSigned && (
          <div className="notice" style={{ maxWidth: 640, width: '100%', textAlign: 'left', marginTop: 8 }}>
            <strong style={{ color: 'var(--va-headline)' }}>On a Mac, the first time</strong>
            <ol style={{ margin: '8px 0', paddingLeft: 20, display: 'grid', gap: 4 }}>
              <li>Open the downloaded file and drag VA Plugin Store into Applications.</li>
              <li>
                Open it. macOS says it can't verify the app: close the message with <strong>Done</strong> (<strong>Cancel</strong> on macOS 13 and 14). Don't click Move to Trash.
              </li>
              <li>
                Open <strong>System Settings → Privacy &amp; Security</strong>, scroll down and click <strong>Open Anyway</strong> next to VA Plugin Store. Confirm with your password or Touch ID, and click <strong>Open</strong> if macOS asks again.
              </li>
            </ol>
            <span className="small muted">
              You only do this once. A version signed by Apple is on its way; the app tells you when it's out. When you install a new version over an old one, your Mac may ask for your password to use the keychain: enter it and click <strong>Always Allow</strong>.
            </span>
          </div>
        )}
      </section>
      <div className="grid" style={{ marginTop: 20 }}>
        {[
          ['Try anything free', 'Every plugin installs as a demo with a moving VA watermark. Buy it and the watermark disappears in seconds.'],
          ['Your licenses, everywhere', 'Sign in on up to 3 computers. Switch accounts and plugins follow the account that is signed in.'],
          ['Works offline', 'Licenses live on your computer and keep working offline for 30 days: safe for festivals and tours.'],
          ['Always up to date', 'Updates show up in your library. One click installs the new version.'],
        ].map(([t, d]) => (
          <div key={t} className="card">
            <h3>{t}</h3>
            <p className="muted" style={{ margin: 0 }}>{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
